export default {"src":"/_next/static/media/top-coverH.b158b56a.svg","height":348,"width":348};